import { AxiosResponse } from "axios";
import { IServicoOrcamento } from "interfaces/orcamento";
import api from "./api";

function ensureSuccess<T>(response: AxiosResponse<T>): T {
  if (response.status >= 400) {
    const data = response.data as { message?: string };
    throw new Error(data?.message || "Falha na comunicação com o servidor");
  }
  return response.data;
}

function normalizeError(error: unknown) {
  const err = error as { response?: { data?: { message?: string } }; message?: string };
  return new Error(
    err?.response?.data?.message || err?.message || "Falha na comunicação com o servidor"
  );
}

export type ServicoOrcamentoPayload = {
  nome: string;
  descricao?: string | null;
  ordem?: number;
  ativo?: boolean;
  exibirSite?: boolean;
  precoUnitario?: number;
  permiteQuantidade?: boolean;
  unidadeMedida?: string;
};

export async function listarServicosOrcamentoAdmin(): Promise<IServicoOrcamento[]> {
  try {
    const response = await api.get<IServicoOrcamento[]>("/orcamento/servicos/admin");
    const data = ensureSuccess(response);
    return Array.isArray(data) ? data : [];
  } catch (error) {
    throw normalizeError(error);
  }
}

export async function criarServicoOrcamento(
  payload: ServicoOrcamentoPayload
): Promise<IServicoOrcamento> {
  try {
    const response = await api.post<IServicoOrcamento>("/orcamento/servicos", payload);
    return ensureSuccess(response);
  } catch (error) {
    throw normalizeError(error);
  }
}

export async function atualizarServicoOrcamento(
  id: number,
  payload: Partial<ServicoOrcamentoPayload>
): Promise<IServicoOrcamento> {
  try {
    const response = await api.put<IServicoOrcamento>(`/orcamento/servicos/${id}`, payload);
    return ensureSuccess(response);
  } catch (error) {
    throw normalizeError(error);
  }
}

export async function deletarServicoOrcamento(id: number): Promise<IServicoOrcamento | void> {
  try {
    const response = await api.delete<IServicoOrcamento>(`/orcamento/servicos/${id}`);
    return ensureSuccess(response);
  } catch (error) {
    throw normalizeError(error);
  }
}

export async function reordenarServicosOrcamento(
  itens: { id: number; ordem: number }[]
): Promise<IServicoOrcamento[]> {
  try {
    const response = await api.patch<IServicoOrcamento[]>("/orcamento/servicos/ordem", {
      itens,
    });
    const data = ensureSuccess(response);
    return Array.isArray(data) ? data : [];
  } catch (error) {
    throw normalizeError(error);
  }
}
